import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import { Layout, Menu, Button } from 'antd';
import { FileTextOutlined, TeamOutlined, LogoutOutlined } from '@ant-design/icons';
import InvoiceManagement from './pages/InvoiceManagement';
import InvoiceDetail from './pages/InvoiceDetail';
import CollaboratorManagement from './pages/CollaboratorManagement';
import CollaboratorDetail from './pages/CollaboratorDetail';
import Login from './pages/Login';
import './App.css';

const { Header, Content } = Layout;

// Protected Route component
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

function AppContent() {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isLoginPage = location.pathname === '/login';
  const isCollaborator = user.role === 'collaborator';
  
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };
  
  // Xác định menu item được chọn dựa trên đường dẫn hiện tại
  const getSelectedKey = () => {
    if (location.pathname.startsWith('/collaborators')) {
      return '2';
    }
    return '1';
  };

  if (isLoginPage) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
      </Routes>
    );
  }

  // Collaborators don't see the navigation menu
  if (isCollaborator) {
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
            Thông tin Cộng tác viên
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span style={{ color: 'white' }}>Xin chào, {user.tele || user.username}</span>
            <Button 
              type="primary" 
              danger 
              icon={<LogoutOutlined />}
              onClick={handleLogout}
            >
              Đăng xuất
            </Button>
          </div>
        </Header>
        <Content>
          <Routes>
            <Route path="/collaborators/:id" element={<ProtectedRoute><CollaboratorDetail /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to={`/collaborators/${user.id}`} replace />} />
          </Routes>
        </Content>
      </Layout>
    );
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Menu theme="dark" mode="horizontal" selectedKeys={[getSelectedKey()]} style={{ flex: 1 }}>
          <Menu.Item key="1" icon={<FileTextOutlined />}>
            <Link to="/">Quản lý Invoice</Link>
          </Menu.Item>
          <Menu.Item key="2" icon={<TeamOutlined />}>
            <Link to="/collaborators">Quản lý Cộng tác viên</Link>
          </Menu.Item>
        </Menu>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <span style={{ color: 'white' }}>Xin chào, {user.username}</span>
          <Button 
            type="primary" 
            danger 
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            Đăng xuất
          </Button>
        </div>
      </Header>
      <Content>
        <Routes>
          <Route path="/" element={<ProtectedRoute><InvoiceManagement /></ProtectedRoute>} />
          <Route path="/invoices/:id" element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
          <Route path="/collaborators" element={<ProtectedRoute><CollaboratorManagement /></ProtectedRoute>} />
          <Route path="/collaborators/:id" element={<ProtectedRoute><CollaboratorDetail /></ProtectedRoute>} />
        </Routes>
      </Content>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </Router>
  );
}

export default App;
